module.exports = __webpack_public_path__ + "img/excel1.e6188283.png";